export default __webpack_public_path__ + "static/media/date-picker.b0ea647d.svg";